import { Dialog } from "@mui/material";
import React from "react";

function Index({ children }) {
  return <Dialog open={true}>{children}</Dialog>;
}

export default Index;
